var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"is-narrow has-background-white",staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.fieldPresenter({item: _vm.asset, header: _vm.header})))])
}
var staticRenderFns = []

export { render, staticRenderFns }